const euroFormatter = new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
})

const euroCompactFormatter = new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
    notation: 'compact',
    maximumFractionDigits: 1,
})

export function formatEuro(value: number): string {
    return euroFormatter.format(value || 0)
}

/** Compact currency for KPI headlines, e.g. € 2,1 mln. */
export function formatEuroCompact(value: number): string {
    return euroCompactFormatter.format(value || 0)
}

/**
 * Share of `value` within `total` as a percentage rounded to `decimals` (default whole numbers).
 * Returns 0 when there is no total to avoid divide-by-zero noise.
 */
export function percentageOf(value: number, total: number, decimals = 0): number {
    if (!total) {
        return 0
    }
    const factor = 10 ** decimals
    return Math.round((value / total) * 100 * factor) / factor
}

/** Percentage with exactly one decimal, nl-NL notation, e.g. "1,4". */
export function formatPercent1(rate: number): string {
    return rate.toLocaleString('nl-NL', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
    })
}
